import React from "react";
import { useTranslation } from "react-i18next";
import {
  SectionWrapper,
  SectionTitle,
  ProposalDataGrid,
  SpanTwo,
} from "./SharedSectionStyles";
import CompactField from "components/CompactField/CompactField";
import { ValidationErrorDisplay } from "components/ValidationErrorDisplay";

interface InsuranceDataSectionProps {
  getError?: (fieldPath: string) => string | undefined;
  disabled?: boolean;
  showPreviousInsuranceEndDate?: boolean;
}

const InsuranceDataSection: React.FC<InsuranceDataSectionProps> = ({
  getError,
  disabled = false,
  showPreviousInsuranceEndDate = true,
}) => {
  const { t } = useTranslation();

  return (
    <SectionWrapper>
      <SectionTitle>
        {t("qtg.proposal.insuranceData.title", "Insurance Data")}
      </SectionTitle>
      <ProposalDataGrid>
        <SpanTwo>
          <div>
            <CompactField
              type="date"
              name="insuranceData.startDate"
              dataHelp="offer-insurance-start-date"
              label="Insurance Start Date"
              translationKey="qtg.proposal.insuranceData.startDate"
              required={true}
              inputStyle={{ width: "150px" }}
              disabled={disabled}
            />
            {getError && (
              <ValidationErrorDisplay error={getError("Insurance.StartDate")} />
            )}
          </div>
        </SpanTwo>
        {showPreviousInsuranceEndDate && (
          <SpanTwo>
            <div>
              <CompactField
                type="date"
                name="insuranceData.previousInsuranceEndDate"
                dataHelp="offer-insurance-previous-end-date"
                label="Previous Insurance End Date"
                translationKey="qtg.proposal.insuranceData.previousInsuranceEndDate"
                required={false}
                inputStyle={{ width: "150px" }}
                disabled={disabled}
              />
            </div>
          </SpanTwo>
        )}
      </ProposalDataGrid>
    </SectionWrapper>
  );
};

export default InsuranceDataSection;
